(function() {
  define('bazemont/constants',['angular'], function() {
    'use strict';
    return angular.module('bazemontConstants', []).constant('BazemontEvents', {
      NEW_EVENT: 'bazemont-events-new-event',
      EDIT_EVENT: 'bazemont-events-edit-event'
    });
  });

}).call(this);

//# sourceMappingURL=constants.js.map
;
